(() => {
  if (window.__TMP_2PLUS1_BROWSE_FLOW__) return;
  window.__TMP_2PLUS1_BROWSE_FLOW__ = true;

  const state = {
    handles: new Set(),
    handlesReady: false,
    shadeQty: 0,
    cart: null,
    syncTimer: null,
    busy: false
  };

  const rootUrl = () => ((window.Shopify?.routes?.root || '/').replace(/\/?$/, '/'));
  const browseUrl = () => `${rootUrl()}collections/bestselling-shades`;
  const normalize = (value) => String(value || '').trim().replace(/\s+/g, ' ');

  const ensureStyles = () => {
    if (document.getElementById('Tmp2Plus1BrowseFlowStyles')) return;
    const style = document.createElement('style');
    style.id = 'Tmp2Plus1BrowseFlowStyles';
    style.textContent = `
      .tmp-2plus1-browse-progress{
        position:fixed;left:50%;bottom:max(14px,env(safe-area-inset-bottom));z-index:46;
        display:flex;align-items:center;justify-content:center;gap:10px;
        width:max-content;max-width:calc(100vw - 28px);min-height:44px;padding:9px 14px;
        border:1px solid #05F3DC;background:#010048;color:#05F3DC;
        box-shadow:0 8px 28px rgba(1,0,72,.18);transform:translateX(-50%);
        font:900 11px/1.1 "Arial Black",Arial,Helvetica,sans-serif;
        letter-spacing:-.02em;text-align:center;text-decoration:none;text-transform:uppercase;
      }
      .tmp-2plus1-browse-progress__label{white-space:nowrap}
      .tmp-2plus1-browse-progress__steps{display:grid;grid-template-columns:repeat(3,18px);gap:4px;flex:0 0 auto}
      .tmp-2plus1-browse-progress__step{display:block;height:4px;border-radius:999px;background:rgba(5,243,220,.28);transition:background .18s ease}
      .tmp-2plus1-browse-progress__step.is-active{background:#05F3DC}
      .tmp-2plus1-browse-progress:hover{background:#05F3DC;color:#010048}
      .tmp-2plus1-browse-progress:hover .tmp-2plus1-browse-progress__step{background:rgba(1,0,72,.25)}
      .tmp-2plus1-browse-progress:hover .tmp-2plus1-browse-progress__step.is-active{background:#010048}
      body.product-template .tmp-2plus1-browse-progress,
      body.cart-template .tmp-2plus1-browse-progress,
      body:has(#CartDrawer[open]) .tmp-2plus1-browse-progress{display:none!important}
      @media(max-width:749px){
        .tmp-2plus1-browse-progress{bottom:max(10px,env(safe-area-inset-bottom));width:calc(100vw - 20px);min-height:42px;padding:8px 11px;font-size:10px;gap:8px}
        .tmp-2plus1-browse-progress__steps{grid-template-columns:repeat(3,16px);gap:3px}
      }
      #CartDrawer .tmp-campaign-cart-status__cta{display:inline-flex;align-items:center;margin-top:5px;color:#010048;font:900 10px/1.1 "Arial Black",Arial,sans-serif;text-decoration:underline;text-underline-offset:2px}
    `;
    document.head.appendChild(style);
  };

  const loadShadeHandles = async () => {
    try {
      const response = await fetch(`${rootUrl()}collections/all-shades/products.json?limit=250`, {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Could not load shade handles');
      const data = await response.json();
      state.handles = new Set((data.products || []).map((product) => product.handle).filter(Boolean));
    } catch (error) {
      console.warn('[TMP 2+1 browse] shade lookup failed', error);
      state.handles = new Set();
    } finally {
      state.handlesReady = true;
    }
  };

  const handleFromCard = (card) => {
    const href = card?.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
    const match = href.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const countShades = (cart) => (cart?.items || []).reduce((sum, item) => {
    return sum + (state.handles.has(item.handle) ? (Number(item.quantity) || 0) : 0);
  }, 0);

  const fetchCart = async () => {
    const response = await fetch(`${rootUrl()}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Could not load cart');
    const cart = await response.json();
    state.cart = cart;
    state.shadeQty = countShades(cart);
    return cart;
  };

  const progressText = (qty) => {
    if (qty <= 0) return '';
    if (qty === 1) return '1/3 SELECTED — ADD 2 MORE';
    if (qty === 2) return '2/3 SELECTED — ADD 1 MORE';
    return '3/3 SELECTED ✓';
  };

  const renderProgress = () => {
    let progress = document.querySelector('.tmp-2plus1-browse-progress');
    if (state.shadeQty <= 0) {
      progress?.remove();
      return;
    }
    if (!progress) {
      progress = document.createElement('a');
      progress.className = 'tmp-2plus1-browse-progress';
      progress.href = browseUrl();
      progress.setAttribute('aria-live', 'polite');
      document.body.appendChild(progress);
    }
    const active = Math.min(Math.max(state.shadeQty, 0), 3);
    const text = progressText(state.shadeQty);
    const steps = [1, 2, 3].map((step) => `<span class="tmp-2plus1-browse-progress__step${step <= active ? ' is-active' : ''}"></span>`).join('');
    const markup = `<span class="tmp-2plus1-browse-progress__label">${text}</span><span class="tmp-2plus1-browse-progress__steps" aria-hidden="true">${steps}</span>`;
    if (progress.innerHTML !== markup) progress.innerHTML = markup;
    progress.setAttribute('aria-label', `Buy 2 Get 1 Free progress. ${text}. Continue shopping shades.`);
  };

  const renderCartCampaign = () => {
    const drawer = document.querySelector('#CartDrawer');
    if (!drawer) return;
    const header = drawer.querySelector('.cart-drawer__header');
    const heading = header?.querySelector('.drawer__heading');
    let banner = header?.querySelector('.tmp-campaign-cart-status');

    if (!heading || state.shadeQty <= 0) {
      banner?.remove();
      return;
    }

    if (!banner) {
      banner = document.createElement('div');
      banner.className = 'tmp-campaign-cart-status';
      heading.after(banner);
    }

    let markup = '';
    if (state.shadeQty === 1) {
      markup = `<span>BUY 2 GET 1 FREE</span><strong>1/3 SELECTED — ADD 2 MORE</strong><small>Automatic — no code needed · Ends Sun 27 Sep 23:59</small><a class="tmp-campaign-cart-status__cta" href="${browseUrl()}">SHOP SHADES →</a>`;
    } else if (state.shadeQty === 2) {
      markup = `<span>BUY 2 GET 1 FREE</span><strong>2/3 SELECTED — ADD 1 MORE</strong><small>Automatic — no code needed · Ends Sun 27 Sep 23:59</small><a class="tmp-campaign-cart-status__cta" href="${browseUrl()}">ADD 1 MORE SHADE →</a>`;
    } else {
      markup = `<span>BUY 2 GET 1 FREE</span><strong>3 SHADES ADDED ✓</strong><small>Automatic — no code needed · Ends Sun 27 Sep 23:59</small>`;
    }

    if (banner.innerHTML !== markup) banner.innerHTML = markup;
    banner.classList.toggle('is-applied', state.shadeQty >= 3);
  };

  const keepCartShoppingUseful = () => {
    const drawer = document.querySelector('#CartDrawer');
    if (!drawer) return;

    drawer.querySelectorAll('.cart-drawer-products-recommendation').forEach((element) => {
      element.classList.remove('tmp-campaign-hidden');
    });

    const shippingGoal = drawer.querySelector('free-shipping-goal');
    if (shippingGoal) shippingGoal.classList.remove('tmp-campaign-hidden');
  };

  const normalizeShippingCopy = () => {
    const root = document.querySelector('#MainContent');
    if (!root) return;
    root.querySelectorAll('p,span,strong,div,li').forEach((element) => {
      if (element.children.length) return;
      const text = normalize(element.textContent);
      if (text === 'Worldwide shipping' || text === 'Free shipping over €100') {
        element.textContent = 'Free shipping on orders over €100';
      }
    });
  };

  const renderUi = () => {
    renderProgress();
    renderCartCampaign();
    keepCartShoppingUseful();
    normalizeShippingCopy();
  };

  const syncUi = async () => {
    if (!state.handlesReady) await loadShadeHandles();
    try {
      await fetchCart();
      renderUi();
    } catch (error) {
      console.warn('[TMP 2+1 browse] cart sync failed', error);
    }
  };

  const scheduleSync = (delay = 140) => {
    clearTimeout(state.syncTimer);
    state.syncTimer = setTimeout(syncUi, delay);
  };

  const addShadeFromCard = async (button, form, variantId) => {
    if (state.busy) return;
    state.busy = true;
    const wasDisabled = button.disabled;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.add('loading');

    try {
      const payload = new FormData(form);
      payload.set('id', variantId);
      payload.set('quantity', '1');

      const response = await fetch(`${rootUrl()}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: payload
      });
      const added = await response.json();
      if (!response.ok || added?.status) throw new Error(added?.description || added?.message || 'Could not add shade');

      await fetchCart();
      renderUi();

      document.dispatchEvent(new CustomEvent('product-ajax:added', {
        detail: { product: added, source: 'tmp-2plus1-browse', shadeQuantity: state.shadeQty }
      }));

      document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { open: false, source: 'tmp-2plus1-browse' }
      }));

      window.setTimeout(renderUi, 220);
      window.setTimeout(renderUi, 520);
    } catch (error) {
      console.error('[TMP 2+1 browse add]', error);
    } finally {
      button.classList.remove('loading');
      button.removeAttribute('aria-busy');
      button.disabled = wasDisabled;
      state.busy = false;
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('.product-card__atc');
    if (!button || button.disabled || button.closest('#CartDrawer')) return;
    if (!state.handlesReady) return;

    const card = button.closest('.product-card');
    const handle = handleFromCard(card);
    if (!handle || !state.handles.has(handle)) return;

    const form = button.closest('form[action*="/cart/add"], form[is="product-form"], form.product-card__actions');
    const variantId = button.dataset.variantId || form?.querySelector('input[name="id"]')?.value;
    if (!form || !variantId) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addShadeFromCard(button, form, variantId);
  }, true);

  ['cart:updated', 'product-ajax:added', 'cart:refresh'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      if (eventName === 'product-ajax:added' && event.detail?.source === 'tmp-2plus1-browse') {
        window.setTimeout(renderUi, 80);
        return;
      }
      scheduleSync(eventName === 'cart:updated' ? 420 : 520);
    });
  });

  document.addEventListener('shopify:section:load', () => scheduleSync(300));

  const init = async () => {
    ensureStyles();
    await loadShadeHandles();
    await syncUi();
    window.setTimeout(renderUi, 650);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
